﻿var modal = {};

modal = {

  init: function () {
    var me = this;
    var modals = document.getElementsByClassName('modal');

    Array.prototype.forEach.call(modals, function (modal, index) {
  
      var overlay = modal.getElementsByClassName('modal__overlay')[0];

      var closeIcon = modal.getElementsByClassName('modal__close')[0];

      if (overlay) {

        overlay.addEventListener('click', function (e) {

          e.preventDefault();
          e.stopPropagation();

          modal.classList.toggle('modal--show');

        });
      }

      if(closeIcon) {

        closeIcon.addEventListener('click', function (e) {

          e.preventDefault();
          e.stopPropagation();
          modal.classList.remove('modal--show');

        });
      }

    });

  },

  toggle: function (id) {
    var modal = document.getElementById(id);

    if (modal) {

      var a = modal.querySelector('.alert');

      if (a) {
        a.remove();
      }
      
      modal.classList.toggle('modal--show');

    }

  }
};

modal.initialize = function () {

  modal.init();
};

module.exports = modal;
